import serviceHub from '@/services/hub';
import { AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';

type UpdateConfig = Services.Player.UpdateConfig;

const actions: ActionTree<Store.Player.State, RootState> = {
  async loadPlayerConfig({ commit, dispatch }, payload: Services.Player.GetConfig): Promise<void> {
    return serviceHub.player.getPlayerConfig(payload)
      .then((res) => {
        // console.log(res.data);
        commit('setPlayerConfig', res.data);
      })
      .catch(() => dispatch(
        'notification/create', {
          text: 'Erro ao buscar a configuração do player',
          type: 'error',
        }, { root: true },
      ));
  },
  async updatePlayerConfig({ commit, dispatch }, payload: UpdateConfig): Promise<any> {
    return serviceHub.player.updatePlayerConfig(payload)
      .then((res: AxiosResponse) => {
        console.log(res.data);
        commit('setPlayerConfig', res.data);
        return res.data;
      })
      .catch(() => dispatch(
        'notification/create', {
          text: 'Erro ao atualizar a configuração do player',
          type: 'error',
        }, { root: true },
      ));
  },
};

export default actions;
